import { shopPrefix } from '../../../config';
import { format } from 'date-fns';
import { http } from '../../axios';

const endpointMarketingMaterial = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/materialurl`;
export function downloadMarketingMaterial(campaignProductId: string) {
    return http.get(endpointMarketingMaterial, { pathParams: { campaignProductId } }).then(response => {
        const file_path = response.data.url;
        const a = document.createElement('A') as HTMLAnchorElement;
        const now = format(new Date(), 'yyyy-mm-dd');
        a.href = file_path;
        a.download = `CampaignReport_${campaignProductId}_${now}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
}
